let previousPagePath = null;

export function trackVirtualPageView(location) {
  if (typeof window === "undefined") {
    return;
  }

  const pagePath = `${location.pathname}${location.search}${location.hash}`;

  if (previousPagePath === null) {
    previousPagePath = pagePath;
    return;
  }

  if (previousPagePath === pagePath) {
    return;
  }

  previousPagePath = pagePath;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "page_view",
    page_path: pagePath,
    page_location: window.location.href,
    page_title: document.title,
  });
}
